<mat-card class="page-card">
  <section class="page-header">
    <div class="page-header-content">
      <div class="page-header-icon">
        <mat-icon>view_module</mat-icon>
      </div>
      <div class="page-header-text">
        <span class="eyebrow">{{ 'dataManagement.title' | transloco }}</span>
        <h1>{{ 'dataManagement.profiles.page.title' | transloco }}</h1>
        <p>{{ 'dataManagement.profiles.page.description' | transloco }}</p>
      </div>
    </div>
  </section>

  <mat-card-content>
    <mat-tab-group class="outer-tab-group">
      <mat-tab [label]="'ppwrDocuments.typeTd' | transloco">
        <div class="tab-content-wrapper">
          <app-td-profile-panel></app-td-profile-panel>
        </div>
      </mat-tab>
      <mat-tab [label]="'ppwrDocuments.typeDoc' | transloco">
        <div class="tab-content-wrapper">
          <app-doc-profile-panel></app-doc-profile-panel>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
